import View from 'app/scripts/views/internal/view';
import CardMemberSelectView from 'app/scripts/views/card/card-member-select-view';
import teacup from 'app/scripts/views/internal/teacup-with-helpers';
import ModelCache from 'app/scripts/db/model-cache';
import {
  getOrLoadCardData,
  loadBoardData,
} from 'app/scripts/controller/display-card-loaders';

const t = teacup();

const template = t.renderable(() =>
  t.div(() => {
    t.span('.spinner.centered.js-spinner');

    t.div('.js-members-view-container');
  }),
);

export class BoardTableCardMemberSelectView extends View {
  initialize() {
    this.viewTitleKey = 'members';
    this.modelCache = ModelCache;
  }

  async renderMembersView() {
    const { idCard } = this.options;
    this.model = await getOrLoadCardData(idCard);

    await loadBoardData(this.model.get('idBoard'));

    this.membersView = this.subview(CardMemberSelectView, this.model);

    this.$('.js-spinner').addClass('hide');
    this.ensureSubview(this.membersView, this.$('.js-members-view-container'));

    return this;
  }

  render() {
    this.$el.html(template());

    this.renderMembersView();

    return this;
  }
}
